"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbInlineMessages = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sbInlineMessage = require("../sb-inline-message/sb-inline-message");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @namespace skybase-components.sb-inline-messages.sb-inline-messages
 */

/**
 * @typedef {Object} skybase-components.sb-inline-messages.sb-inline-messages#props
 *
 * @property {Array.<skybase-components.sb-inline-messages.sb-inline-messages#props>} alerts configurations
 */

/**
 * @description
 * SbAlerts is list of more alerts
 * @function
 *
 * @name skybase-components.sb-inline-messages.sb-inline-messages#SbAlerts
 * @param  {skybase-components.sb-inline-messages.sb-inline-messages#props} props - The key-value pairs.
 * @return {Array<React.Component>}
 */
var SbInlineMessages = function SbInlineMessages(props) {
  var alerts;

  if (props.alerts) {
    // eslint-disable-line
    var clearedAlerts = (0, _utils.clearDuplicateAlerts)(props.alerts);
    alerts = clearedAlerts.map(function (notification) {
      var id = notification.id,
          title = notification.title,
          _notification$titlePa = notification.titleParams,
          titleParams = _notification$titlePa === void 0 ? {} : _notification$titlePa,
          message = notification.message,
          _notification$message = notification.messageParams,
          messageParams = _notification$message === void 0 ? {} : _notification$message,
          severity = notification.severity;
      return /*#__PURE__*/_react.default.createElement(_sbInlineMessage.SbInlineMessage, {
        key: id,
        type: severity,
        title: title,
        titleParams: titleParams,
        message: message,
        messageParams: messageParams
      });
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-inline-messages"
  }, alerts);
};

exports.SbInlineMessages = SbInlineMessages;
SbInlineMessages.propTypes = {
  alerts: _propTypes.default.arrayOf(_propTypes.default.object)
};
SbInlineMessages.defaultProps = {
  alerts: null
};
//# sourceMappingURL=sb-inline-messages.js.map